import React, { useContext } from "react";
import CommonModal from "../CommonModal";
import { EditorInfoContext } from "../../../utils/userInfoContext";
import { networkService } from "../../config/axios";
import { deleteElementById, restoreElementById } from "../../../utils/elementHistoryActions";
import Button from "../../Elements/Button";

const DeleteElementModal = ({ openDeleteModal, closeModal, elemId, modalType }) => {
    const { setElements, lightBoxList, setLightBoxList, editElement, setEditElement, setShowToast, setImageElement, pushHistoryAction, elementsToRemove, setElementsToRemove } = useContext(EditorInfoContext)

    const bulkElements = (Array.isArray(elementsToRemove) ? elementsToRemove : []).filter((el) => el?.id);
    const isBulk = bulkElements.length > 0 && modalType !== 'lightbox';
    const isSlide = !isBulk && modalType !== 'lightbox' && editElement?.element_type === 4 && (!!editElement?.docs_lightbox_id || !editElement?.page);

    const handleClose = () => {
        closeModal(false)
        setEditElement({})
        setElementsToRemove?.([])
    }

    const dropElementsFromState = (ids) => {
        setElements(prevElements => {
            const newElements = { ...prevElements };
            ids.forEach((id) => delete newElements[id]);
            return newElements;
        });
        setImageElement(prevElements => {
            const newElements = { ...prevElements };
            ids.forEach((id) => delete newElements[id]);
            return newElements;
        });
    };

    const restoreElements = (ids) =>
        Promise.all(
            ids.map((id) =>
                restoreElementById(id).then((response) => {
                    if (response?.data?.id) {
                        setElements(prev => ({ ...prev, [response.data.id]: response.data }));
                    }
                    return response;
                })
            )
        );

    const softDeleteElements = (ids) =>
        Promise.all(ids.map((id) => deleteElementById(id))).then(() => dropElementsFromState(ids));

    const handleDeleteBulk = async () => {
        const ids = bulkElements.map((el) => el.id);
        const results = await Promise.all(
            ids.map((id) =>
                networkService(`docs/elements/${id}.json`, 'DELETE')
                    .then((response) => ({ id, ok: response.status == 204 }))
                    .catch(() => ({ id, ok: false }))
            )
        );

        const deletedIds = results.filter((r) => r.ok).map((r) => r.id);
        const failedCount = results.length - deletedIds.length;

        if (deletedIds.length) {
            dropElementsFromState(deletedIds);
            const noun = deletedIds.length === 1 ? 'element' : 'elements';
            setShowToast({
                showToast: true,
                toastType: failedCount ? 'alert' : 'success',
                toastMessage: failedCount
                    ? `${deletedIds.length} ${noun} deleted, ${failedCount} could not be deleted`
                    : `${deletedIds.length} ${noun} deleted`
            })

            if (pushHistoryAction) {
                pushHistoryAction({
                    label: 'Delete elements',
                    undo: () => restoreElements(deletedIds),
                    redo: () => softDeleteElements(deletedIds),
                });
            }
        } else {
            setShowToast({
                showToast: true,
                toastType: 'danger',
                toastMessage: "Something went wrong"
            })
        }

        setEditElement({})
        setElementsToRemove?.([])
        closeModal(false)
    };

    const handleDeleteElement = async (elemId) => {
        if (modalType == 'lightbox') {
            let lightboxDeleted;
            try {
                lightboxDeleted = await networkService(`docs/lightboxes/${elemId}.json`, 'DELETE');
            } catch (err) {
                lightboxDeleted = err?.response;
            }
            if (lightboxDeleted?.status == 204) {
                setShowToast({
                    showToast: true,
                    toastType: 'success',
                    toastMessage: "Lightbox deleted"
                })
                setLightBoxList(lightBoxList.filter(element => element.id !== elemId))
            } else {
                setShowToast({
                    showToast: true,
                    toastType: 'danger',
                    toastMessage: lightboxDeleted?.data?.error || "Something went wrong"
                })
            }
            closeModal(false)
        } else {
            const DeleteElement = await networkService(`docs/elements/${elemId}.json`, 'DELETE');
            if (DeleteElement.status == 204) {
                setShowToast({
                    showToast: true,
                    toastType: 'success',
                    toastMessage: "Element Deleted"
                })
                dropElementsFromState([elemId]);
                if (pushHistoryAction && elemId) {
                    pushHistoryAction({
                        label: 'Delete element',
                        undo: () => restoreElements([elemId]),
                        redo: () => softDeleteElements([elemId]),
                    });
                }
            } else {
                setShowToast({
                    showToast: true,
                    toastType: 'danger',
                    toastMessage: "Something went wrong"
                })
            }
            setEditElement({})
            closeModal(false)
        }
    }

    return (
        <CommonModal
            title={modalType === 'lightbox' && !isBulk ? "Remove Lightbox" : isSlide ? "Remove image" : "Remove Element"}
            modalStatus={openDeleteModal}
            changeActiveStatus={closeModal}
            classList="header-profile-modal-wrapper alert-modal"
            showFooter={false}
            centered
        >
            <div>
                <p className="mb-2">
                    {isBulk
                        ? `Are you sure you want to delete ${bulkElements.length > 1 ? `these ${bulkElements.length} Elements` : 'this Element'} ?`
                        : isSlide
                            ? 'Remove this image from the slideshow?'
                            : `Are you sure you want to delete this ${modalType === 'lightbox' ? 'Lightbox' : 'Element'} ?`}
                </p>
                <div className="kdf-btn mt-3">
                    <Button
                        text={'Cancel'}
                        classList={"alert"}
                        addonClass={'me-3'}
                        onClick={() => handleClose()}
                    />
                    <Button
                        text={'Yes'}
                        classList={"success"}
                        type="submit"
                        addonClass={'px-2 common-modal-yes-button'}
                        onClick={() => (isBulk ? handleDeleteBulk() : handleDeleteElement(elemId))}
                    />
                </div>
            </div>
        </CommonModal>
    )
}
export default DeleteElementModal
